const { Tooltip } = globalThis.unlk;

document.addEventListener('DOMContentLoaded', () => {
  const shareHolder = document.querySelector('.share-holder');
  if (!shareHolder) return;

  const announce = shareHolder.querySelector('#copy-announce');
  const copyBtns = shareHolder.querySelectorAll('.copy-btn');

  for (const btn of copyBtns) {
    // Hover-only = no "sticky until blur" behavior
    const tooltip = Tooltip.getOrCreateInstance(btn, {
      trigger: 'hover'
    });

    const originalTitle = btn.getAttribute('data-bs-title') || 'Copy post URL';

    // Ensure base title is set once
    btn.setAttribute('data-bs-title', originalTitle);

    btn.addEventListener('click', async (e) => {
      e.preventDefault();

      const text = String(btn.dataset.clipboard || '');
      const copied = await copyText(text);

      if (copied) {
        onCopySuccess(btn, announce);
        flashTooltip(btn, tooltip, originalTitle, 'Copied');
      } else {
        onCopyFail(announce);
        flashTooltip(btn, tooltip, originalTitle, 'Copy failed');
      }
    });
  }
});

/* -------------------------------------------------------------------------- */
/* Helpers                                                                     */
/* -------------------------------------------------------------------------- */

async function copyText(text) {
  if (!text) return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {}
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.readOnly = true;
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.append(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return Boolean(ok);
  } catch {
    return false;
  }
}

function flashTooltip(btn, tooltip, original, temp) {
  // Clear any pending revert
  if (btn._copyTooltipTimer) {
    globalThis.clearTimeout(btn._copyTooltipTimer);
    btn._copyTooltipTimer = null;
  }

  // Update the currently-rendered tooltip content (if visible)
  tooltip.setContent({ '.tooltip-inner': temp });

  // If user isn't hovering (tooltip not visible), briefly show it on click
  // This will still behave like a tooltip: it’ll disappear on mouseleave
  tooltip.show();

  btn._copyTooltipTimer = globalThis.setTimeout(() => {
    tooltip.setContent({ '.tooltip-inner': original });
    // If user is not hovering anymore, hide it. If they are hovering, it stays (normal behavior).
    if (!btn.matches(':hover')) tooltip.hide();
    btn._copyTooltipTimer = null;
  }, 1200);

  // Ensure it never gets “stuck” if the mouse leaves
  const onLeave = () => {
    tooltip.hide();
    btn.removeEventListener('mouseleave', onLeave);
  };

  btn.addEventListener('mouseleave', onLeave);
}

function onCopySuccess(btn, announce) {
  btn.classList.add('copied');
  if (announce) announce.textContent = 'Link copied to clipboard';

  setTimeout(() => {
    btn.classList.remove('copied');
    if (announce) announce.textContent = '';
  }, 1200);
}

function onCopyFail(announce) {
  if (!announce) return;
  announce.textContent = 'Copy failed';
}
